export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    console.error('🌍 Global Error:', err)
    console.error('🧩 Component Info:', info)
    console.error('📌 Stack Trace:', err.stack)
  }
})
